import actions from "@state/actions";
import { Dispatch } from "redux";

export const generateToken = (dispatch: Dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.storage.generateToken((result, error) => {
      if (error) reject(error);
      else resolve(result);
    }))
  });
}